export default function Logo({ size = 30, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      data-testid="obscura-logo"
    >
      <circle cx="24" cy="24" r="21" stroke="#FFFFFF" strokeWidth="2.5" />
      <path d="M24 3 L24 17" stroke="#FFFFFF" strokeWidth="2.5" />
      <path d="M42.2 13.5 L30.1 20.5" stroke="#FFFFFF" strokeWidth="2.5" />
      <path d="M42.2 34.5 L30.1 27.5" stroke="#FFFFFF" strokeWidth="2.5" />
      <path d="M24 45 L24 31" stroke="#FFFFFF" strokeWidth="2.5" />
      <path d="M5.8 34.5 L17.9 27.5" stroke="#FFFFFF" strokeWidth="2.5" />
      <path d="M5.8 13.5 L17.9 20.5" stroke="#FFFFFF" strokeWidth="2.5" />
      <circle cx="24" cy="24" r="7" fill="#D4AF37" />
    </svg>
  );
}
